// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3aJmL","choiceBoxes":"toolbarselects_choiceBoxes__2DFSv","simpleField":"toolbarselects_simpleField__2JOf0"};